(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hp7O9", function(module, exports) {
const $cabad3ef0d2539a1$var$open = document.querySelector(".js-modal-open");
const $cabad3ef0d2539a1$var$close = document.querySelector(".js-modal-close");
const $cabad3ef0d2539a1$var$modal = document.querySelector(".js-backdrop");
$cabad3ef0d2539a1$var$open.addEventListener("click", $cabad3ef0d2539a1$var$openModal);
$cabad3ef0d2539a1$var$close.addEventListener("click", $cabad3ef0d2539a1$var$closeModal);
function $cabad3ef0d2539a1$var$openModal() {
    $cabad3ef0d2539a1$var$modal.classList.remove("is-hidden");
    document.body.classList.add("no-scroll");
    document.addEventListener("keydown", $cabad3ef0d2539a1$var$closeModalWithEsc);
    $cabad3ef0d2539a1$var$modal.addEventListener("click", $cabad3ef0d2539a1$var$closeModalBackdropClick);
}
function $cabad3ef0d2539a1$var$closeModal() {
    $cabad3ef0d2539a1$var$modal.classList.add("is-hidden");
    document.body.classList.remove("no-scroll");
    document.removeEventListener("keydown", $cabad3ef0d2539a1$var$closeModalWithEsc);
    $cabad3ef0d2539a1$var$modal.removeEventListener("click", $cabad3ef0d2539a1$var$closeModalBackdropClick);
}
function $cabad3ef0d2539a1$var$closeModalWithEsc(e) {
    if (e.code === "Escape") $cabad3ef0d2539a1$var$closeModal();
}
function $cabad3ef0d2539a1$var$closeModalBackdropClick(e) {
    if (e.target === $cabad3ef0d2539a1$var$modal) $cabad3ef0d2539a1$var$closeModal();
}

});

parcelRegister("i8Q71", function(module, exports) {
const $d35165bd5db5382a$var$homeLink = document.querySelector(".js-home-link");
const $d35165bd5db5382a$var$aboutLink = document.querySelector(".js-about-link");
const $d35165bd5db5382a$var$productsLink = document.querySelector(".js-products-link");
const $d35165bd5db5382a$var$contactsLink = document.querySelector(".js-contacts-link");
const $d35165bd5db5382a$var$aboutPage = document.querySelector(".about-container");
const $d35165bd5db5382a$var$productsPage = document.querySelector(".products-container");
const $d35165bd5db5382a$var$contactsPage = document.querySelector(".contacts-container");
if ($d35165bd5db5382a$var$aboutPage) $d35165bd5db5382a$var$aboutLink.classList.add("header-active-link");
else if ($d35165bd5db5382a$var$productsPage) $d35165bd5db5382a$var$productsLink.classList.add("header-active-link");
else if ($d35165bd5db5382a$var$contactsPage) $d35165bd5db5382a$var$contactsLink.classList.add("header-active-link");
else $d35165bd5db5382a$var$homeLink.classList.add("header-active-link");

});

parcelRequire("hp7O9");
parcelRequire("i8Q71");

})();
//# sourceMappingURL=imprint.44d56db8.js.map
